// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card_svnm6","body":"Card_body_K6FFE","count":"Card_count_2Qy8X"};